import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { storeByIdAction } from "../actions/store";
import { useLocation } from "react-router-dom";
import { backendImageUrl } from "../Router/constant";

export default function ViewStore() {
  const dispatch = useDispatch();
  const location = useLocation();
  const StoreId = location.pathname?.split("/")[2];
  const { storeListById } = useSelector((state) => state.store);

  useEffect(() => {
    dispatch(storeByIdAction(StoreId));
  }, [StoreId]);

  const data = storeListById?.data;
  const createdBy = data?.createdBy;

  // ✅ Hide Created By if same as seller
  const isSamePerson =
    createdBy?.name &&
    data?.sellerName &&
    createdBy.name === data.sellerName;

  return (
    <div className="container-fluid mainContainer-section">
      <div className="row">
        <div className="col-md-12">
          <div className="storeMainImage">
            <img
              src={backendImageUrl + data?.mainImage?.fileName}
              alt=""
            />
          </div>

          <div className="storeSubimagesOuter">
            {data?.images?.map((item, index) => (
              <div className="storeSubimages" key={index}>
                <img src={backendImageUrl + item?.fileName} alt="" />
              </div>
            ))}
          </div>
        </div>

        <div className="col-md-12">
          <div className="catgeoryBadge">
            <p className="m-0 badgeSection">
              # {data?.category?.name?.en}
            </p>
          </div>

          <div>
            <h2>{data?.shopName?.en || ""}</h2>
            <p
              dangerouslySetInnerHTML={{
                __html: data?.description?.en || "",
              }}
            />
          </div>

          {/* ✅ Store Owner Section */}
          <div className="storeDetailsSection">
            <h3 className="m-0">Store Owner Details</h3>

            {data?.sellerName && (
              <div className="storeUserDetails">
                <h4 className="m-0">Owner Name:</h4>
                <p className="m-0">{data.sellerName}</p>
              </div>
            )}

            {data?.contact?.email && (
              <div className="storeUserDetails">
                <h4 className="m-0">Business Email:</h4>
                <p className="m-0">{data.contact.email}</p>
              </div>
            )}

            {data?.contact?.phone && (
              <div className="storeUserDetails">
                <h4 className="m-0">Business Phone:</h4>
                <p className="m-0">{data.contact.phone}</p>
              </div>
            )}

            {data?.contact?.website && (
              <div className="storeUserDetails">
                <h4 className="m-0">Website:</h4>
                <p className="m-0">{data.contact.website}</p>
              </div>
            )}

            {data?.address?.full && (
              <div className="storeUserDetails">
                <h4 className="m-0">Address:</h4>
                <p className="m-0">{data.address.full}</p>
              </div>
            )}
          </div>

          {(createdBy?.name || createdBy?.email || createdBy?.phone) && (
            <div className="storeDetailsSection">
              <h3 className="m-0 d-flex align-items-center gap-2">
                Created By (User Account)
              </h3>

              {createdBy?.name && (
                <div className="storeUserDetails">
                  <h4 className="m-0">Name:</h4>
                  <p className="m-0">{createdBy.name}</p>
                </div>
              )}

              {createdBy?.email && (
                <div className="storeUserDetails">
                  <h4 className="m-0">Email:</h4>
                  <p className="m-0">{createdBy.email}</p>
                </div>
              )}

              {createdBy?.phone && (
                <div className="storeUserDetails">
                  <h4 className="m-0">Phone:</h4>
                  <p className="m-0">{createdBy.phone}</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}